import { PamtokenService } from './../../core/services/pamtoken.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WelcomepageComponent } from './welcomepage.component';

const routes: Routes = [
  { path: '', component: WelcomepageComponent,
 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers:[PamtokenService]
})
export class WelcomepageRoutingModule { }
